/**
 * Player-level master volume factor (0..1) applied on top of authored element
 * volumes. Written only by `usePlayerVolume` (the shared speaker/slider
 * control); read by `VideoCreatorStore`'s volume pushes (the key-frame
 * playback loop and `applyVolumeForElement`) so authored-volume re-pushes
 * don't stomp a player-level mute. Resets to 1 when the volume control
 * unmounts, so nothing leaks across surfaces.
 */
let masterPlaybackVolumeFactor = 1;

export function setMasterPlaybackVolumeFactor(value: number): void {
  masterPlaybackVolumeFactor = Math.min(1, Math.max(0, value));
}

export function getMasterPlaybackVolumeFactor(): number {
  return masterPlaybackVolumeFactor;
}
